import React, { Dispatch, SetStateAction,useRef,useState } from 'react';
import {CUSTOMER_DOCUMENTS, useGetCustomerAllDocuments} from 'hooks/customer/documents.hooks';

// material-ui
import { Autocomplete,Popper, Chip,  Box, ClickAwayListener,Button,MenuItem, Select, ButtonGroup, Checkbox, Dialog, FormControlLabel, FormGroup, Grid, Radio, RadioGroup, TextField, Tooltip, Typography } from '@mui/material';
import {RangeInput} from '@mui/lab/DateRangePicker/RangeTypes';

// third-party
import {FormattedMessage} from 'react-intl';
import {IconCalendarTime, IconTable} from '@tabler/icons';

// locale
import {addDays, addYears, endOfMonth, parseJSON, startOfMonth, subDays} from 'date-fns';

// project imports
import MainCard from 'ui-component/cards/MainCard';
import DocumentsTable from './Table';
import DocumentPreview from './DocumentPreview';
import {DocumentStatus, documentStatuses, ExtendedDocument} from 'types/DocumentsTypes/Document';

// assets
import Loader from 'ui-component/Loader';
import {useQueryClient} from 'react-query';
import {useDispatch, useSelector} from 'react-redux';
import MyRangePicker from '../../../../ui-component/MyRangePicker';
import CalendarContainer from 'ui-component/calendar-container/calendar-container';
import { getMasterFilterState, setMasterFilterState } from "../../../../ui-component/master-filter-bar";
import {DatePicker, LocalizationProvider} from '@mui/lab';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import config from 'config';
import {enUS, he} from 'date-fns/locale';
import {selectCustomers} from "../../../../store/customers/customersSlice";
import {documentTypes} from "../../../../types/DocumentsTypes/utils";
import JSDB from "../../../../fromKotlin/nk";



export const SmartFilter = ({ filters, onApplyFilter, onRemoveFilter, activeValues }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [open, setOpen] = useState(false);
    const [selectedFilter, setSelectedFilter] = useState(filters[0]);
    const [value, setValue] = useState([]);
    const [inputValue, setInputValue] = useState('');
    console.log(value)
    const [addedFilters, setAddedFilters] = useState(() => {
        return filters
            .map(f => f.id)
            .filter(id => activeValues[id] && activeValues[id].length > 0);
    });
    const buttonRef = useRef();

    const handleOpen = (event, filter = null) => {
        setAnchorEl(event.currentTarget);
        setOpen(true);
        const targetFilter = filter || filters[0];
        setSelectedFilter(targetFilter);
        setValue(activeValues[targetFilter.id] || []);
        setInputValue('');
    };

    const handleApply = () => {
        onApplyFilter({ property: selectedFilter.id, values: value });
        if (!addedFilters.includes(selectedFilter.id)) {
            setAddedFilters(prev => [...prev, selectedFilter.id]);
        }
        setOpen(false);
    };

    const handleClose = () => {
        setOpen(false);
        setValue([]);
        setInputValue('');
    };

    const handleDelete = (filterId) => {
        onRemoveFilter({ property: filterId });
        setAddedFilters((prev) => prev.filter(id => id !== filterId));
    };

    const getAvailableFilters = () => filters.filter(f => !addedFilters.includes(f.id));
    const getOptionLabel = (option) => typeof option === 'string' ? option : option?.label || '';
    const isOptionEqualToValue = (option, val) => {
        if (typeof option === 'string' || typeof val === 'string') return option === val;
        return option?.value === val?.value;
    };
    const addUniqueOptions = (prev, optionsToAdd) => {
        const all = [...prev, ...optionsToAdd];
        const seen = new Set();
        return all.filter((item) => {
            const key = (typeof item === 'string') ? item : String(item?.value ?? item?.label ?? '');
            if (seen.has(key)) return false;
            seen.add(key);
            return true;
        });
    };
    const filterOptions = (options, state) => {
        const q = (state?.inputValue || '').trim().toLowerCase();
        // Deduplicate by option value to avoid duplicated rows in popup
        const deduped = options.filter((opt, idx, arr) => {
            const key = (typeof opt === 'string') ? opt : String(opt?.value ?? opt?.label ?? '');
            return arr.findIndex((x) => ((typeof x === 'string') ? x : String(x?.value ?? x?.label ?? '')) === key) === idx;
        });
        if (!q) return deduped;
        const terms = q.split(/[,\s;]+/).filter(Boolean);
        if (terms.length === 0) return deduped;
        // AND matching for better relevance (all typed terms must appear)
        return deduped.filter((option) => {
            const label = getOptionLabel(option).toLowerCase();
            return terms.every((t) => label.includes(t));
        });
    };
    const handleAutocompleteKeyDown = (e) => {
        if (e.key !== 'Enter') return;
        if (selectedFilter?.id !== 'clients' && selectedFilter?.id !== 'products') return;
        e.preventDefault();
        e.stopPropagation();
        const q = (inputValue || '').trim().toLowerCase();
        if (!q) return;
        const terms = q.split(/[,\s;]+/).filter(Boolean);
        if (terms.length === 0) return;
        const matched = (selectedFilter?.options || []).filter((option) => {
            const label = getOptionLabel(option).toLowerCase();
            return terms.some((t) => label.includes(t));
        });
        if (matched.length > 0) {
            setValue((prev) => addUniqueOptions(prev, matched));
        }
    };

    return (
        <Box display="flex" gap={1} flexWrap="wrap">
            {addedFilters.map((fid) => {
                const filter = filters.find(f => f.id === fid);
                if (!filter) return null;
                return (
                    <Chip
                        key={filter.id}
                        label={filter.label}
                        onClick={(e) => handleOpen(e, filter)}
                        onDelete={() => handleDelete(filter.id)}
                        color="primary"
                        variant="outlined"
                    />
                );
            })}

            {getAvailableFilters().length > 0 && (
                <Chip
                    label="+ סינון מתקדם"
                    onClick={handleOpen}
                    ref={buttonRef}
                    color="secondary"
                    variant="outlined"
                />
            )}

            <Popper open={open && anchorEl!=null} anchorEl={anchorEl} placement="bottom-start" disablePortal style={{ zIndex: 1300 }}>
                <Box p={2} bgcolor="white" boxShadow={3} minWidth={300}>
                    <Typography variant="subtitle1">פילטרים פעילים</Typography>
                    {[...addedFilters, selectedFilter.id].filter((v, i, a) => a.indexOf(v) === i).map(fid => {
                        const filter = filters.find(f => f.id === fid);
                        return (
                            <Box key={fid} mb={1}>
                                <Typography variant="caption" color="textSecondary">
                                    {filter?.label}: {(activeValues[fid]?.label || []).join(', ')}
                                </Typography>
                            </Box>
                        );
                    })}

                    {getAvailableFilters().length > 0 && (
                        <>
                            <Typography variant="subtitle2" mt={2}>הוסף פילטר</Typography>
                            <Select
                                value={selectedFilter.id}
                                onChange={(e) => {
                                    const newFilter = filters.find(f => f.id === e.target.value);
                                    setSelectedFilter(newFilter);
                                    setValue(activeValues[newFilter.id] || []);
                                }}
                                fullWidth
                                size="small"
                                style={{ marginBottom: 12 }}
                            >
                                {getAvailableFilters().map(filter => (
                                    <MenuItem key={filter.id} value={filter.id}>{filter.label}</MenuItem>
                                ))}
                            </Select>
                        </>
                    )}

                    <Autocomplete
                        multiple
                        options={selectedFilter.options}
                        disableCloseOnSelect
                        getOptionLabel={getOptionLabel}
                        filterOptions={filterOptions}
                        isOptionEqualToValue={isOptionEqualToValue}
                        value={value}
                        onChange={(e, newVal) => setValue(newVal)}
                        inputValue={inputValue}
                        onInputChange={(e, newVal, reason) => {
                            // For clients filter keep typed search after selection so user can continue quickly.
                            if ((selectedFilter?.id === 'clients' || selectedFilter?.id === 'products') && reason === 'reset') return;
                            setInputValue(newVal);
                        }}
                        renderTags={(tagValue, getTagProps) => {
                            if (selectedFilter?.id === 'clients' || selectedFilter?.id === 'products') {
                                if (!tagValue?.length) return null;
                                const noun = selectedFilter.id === 'products' ? 'מוצרים' : 'לקוחות';
                                return (
                                    <Chip
                                        {...getTagProps({ index: 0 })}
                                        label={`${tagValue.length} ${noun} נבחרו`}
                                        size="small"
                                    />
                                );
                            }
                            return tagValue.map((option, index) => (
                                <Chip
                                    {...getTagProps({ index })}
                                    key={typeof option === 'string' ? option : option?.value ?? index}
                                    label={getOptionLabel(option)}
                                    size="small"
                                />
                            ));
                        }}
                        renderOption={(props, option, { selected }) => (
                            <li {...props}>
                                <Checkbox checked={selected} size="small" style={{ marginInlineEnd: 8 }} />
                                {getOptionLabel(option)}
                            </li>
                        )}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label={`בחר ${selectedFilter.label}`}
                                size="small"
                                onKeyDown={handleAutocompleteKeyDown}
                            />
                        )}
                    />

                    <Box mt={2} display="flex" justifyContent="space-between">
                        <Button onClick={handleClose} size="small">סגור</Button>
                        <Button onClick={handleApply} color="primary" size="small" variant="contained">החל</Button>
                    </Box>
                </Box>
            </Popper>
        </Box>
    );
};


export const DocumentsFilterBar = ({
                                       status,
                                       setStatus,
                                       range,
                                       setRange,
                                       isLoading,
                                       tableName,
                                       singleDate,
                                       setSingleDate,
                                       byOrder,
                                       setByOrder,
                                       byBase,
                                       setByBase,
                                       savePriceInClient,
                                       setSavePriceInClient,
                                       setInventory,
                                       inventory,
                                       documenFor,
                                       setDocumentFor,
                                       clientids,
                                       setClientIds,
                                       productids,
                                       setProductIds,
                                       // optional statistics controls props
                                       statisticsEnabled,
                                       setStatisticsEnabled,
                                       distanceStd,
                                       setDistanceStd,
                                       showExceptionsOnly,
                                       setShowExceptionsOnly,
                                       groupingMode,
                                       setGroupingMode,
                                       // optional controlled outlier toggles
                                       includePriceOutliers,

                                       includeRatioOutliers,
                                        setIncludePriceOutliers,
                                        setIncludeRatioOutliers,

                                       // optional callback to notify parent when outlier type toggles change
                                       onOutlierTogglesChange,
                                       enableFromDateFilter
                                   }) => {
    const data = getMasterFilterState(tableName);
    const [radio_value, setRadioValue] = useState(data?.radio_value || 'from');
    React.useEffect(() => {
        if (radio_value === 'fromStart' && enableFromDateFilter && setRange) {
            const from = range?.[0] ? new Date(range[0] as any) : new Date();
            setRange([from, addYears(new Date(), 5)]);
            if (setSingleDate) setSingleDate(undefined);
        }
        // apply persisted "from date" mode once on mount
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const clients = useSelector(selectCustomers);
    const clientOptions = React.useMemo(() => {
        const byId = new Map<string, any>();
        clients.forEach((client: any) => {
            const id = String(client?.id ?? '');
            if (!id) return;
            if (!byId.has(id)) byId.set(id, client);
        });
        const uniqueClients = Array.from(byId.values());
        const nameCount = uniqueClients.reduce((acc: Record<string, number>, c: any) => {
            const key = String(c?.name ?? '').trim();
            acc[key] = (acc[key] || 0) + 1;
            return acc;
        }, {});
        return uniqueClients.map((client: any) => {
            const name = String(client?.name ?? '');
            const shouldShowId = (nameCount[name] || 0) > 1;
            return {
                label: shouldShowId ? `${name} (${client.id})` : name,
                value: client.id
            };
        });
    }, [clients]);
    const documentOptions = Object.keys(documentTypes).map((d) => ({ label: documentTypes[d].name, value: d }));
    const productOptions = React.useMemo(() => {
        if (!setProductIds) return [];
        let products: any[] = [];
        try {
            products = JSDB().getAllClientProduct(true)?.first?.toArray?.() ?? [];
        } catch (e) {
            products = [];
        }
        const nameCount = products.reduce((acc: Record<string, number>, p: any) => {
            const key = String(p?.getName?.() || p?.name || '').trim();
            acc[key] = (acc[key] || 0) + 1;
            return acc;
        }, {});
        return products.map((p: any) => {
            const name = String(p?.getName?.() || p?.name || '');
            const code = String(p?.getExternalId?.() || p?.external_id || p?.getBarcode?.() || '').trim();
            const showId = (nameCount[name.trim()] || 0) > 1;
            const label = [name, code ? `(${code})` : '', showId ? `#${p.id}` : ''].filter(Boolean).join(' ');
            return { label, value: Number(p.id) };
        }).filter((p) => Number.isFinite(p.value));
    }, [setProductIds]);


    const filters = [
        {
            id: 'documentTypes',
            label: 'סוגי מסמכים',
            options: documentOptions
        },
        {
            id: 'clients',
            label: 'לקוחות',
            options: clientOptions
        },
        ...(setProductIds ? [{
            id: 'products',
            label: 'מוצרים',
            options: productOptions
        }] : []),

    ];

    const activeValues = {
        status: status || [],
        clients: clientids || [],
        documentTypes: documenFor || [],
        products: productids || []
    };
    console.log(activeValues)

    const onApplyFilter = (filter) => {
        switch (filter.property) {
            case 'status':
                setStatus && setStatus(filter.values);
                break;
            case 'clients':
                setClientIds && setClientIds(filter.values);
                break;
            case 'documentTypes':
                setDocumentFor && setDocumentFor(filter.values);
                break;
            case 'products':
                setProductIds && setProductIds(filter.values);
                break;
        }
    };

    const onRemoveFilter = (filter) => {
        switch (filter.property) {
            case 'status':
                setStatus && setStatus([]);
                break;
            case 'clients':
                setClientIds && setClientIds([]);
                break;
            case 'documentTypes':
                setDocumentFor && setDocumentFor([]);
                break;
            case 'products':
                setProductIds && setProductIds([]);
                break;
        }
    };
    return (
        <Grid spacing={1} style={{
            display: 'flex',
            justifyContent: 'start',
            alignItems: 'center',
            width: '100%',
            gap: 8,
            flexWrap: 'nowrap',
            overflowX: 'auto'
        }} container>
            <Grid item style={{ flex: '0 0 auto' }} >
                {radio_value === "unique" && (
                    <LocalizationProvider dateAdapter={AdapterDateFns} locale={config.i18n === 'he' ? he : enUS}>
                        <DatePicker
                            mask=''
                            renderInput={(props) => <TextField {...props} />}
                            label={"עד תאריך הפקדה"}
                            value={singleDate || null}
                            onChange={(newValue) => {
                                if (newValue && !isNaN(newValue.getDate()) && setSingleDate) setSingleDate(newValue);
                            }}
                        />
                    </LocalizationProvider>
                )}
                {radio_value === "fromStart" && enableFromDateFilter && (
                    <LocalizationProvider dateAdapter={AdapterDateFns} locale={config.i18n === 'he' ? he : enUS}>
                        <DatePicker
                            mask=''
                            renderInput={(props) => <TextField {...props} />}
                            label={"החל מתאריך"}
                            value={range?.[0] || null}
                            onChange={(newValue) => {
                                if (newValue && !isNaN(newValue.getDate()) && setRange) {
                                    if (setSingleDate) setSingleDate(undefined);
                                    setRange([newValue, addYears(new Date(), 5)]);
                                }
                            }}
                        />
                    </LocalizationProvider>
                )}
                {(radio_value === "from" && range) &&
                    <MyRangePicker range={range} setRange={setRange} isLoading={isLoading}/>}
                {setDocumentFor || setClientIds || setProductIds ?          <SmartFilter
                    filters={filters}
                    onApplyFilter={onApplyFilter}
                    onRemoveFilter={onRemoveFilter}
                    activeValues={activeValues}
                />: undefined}

            </Grid>
            {

                (setSingleDate) &&
                <Grid item style={{ flex: '0 0 auto' }}>
                    <RadioGroup
                        row
                        value={radio_value}
                        aria-labelledby='demo-form-control-label-placement'
                        name='position'
                        onChange={(e) => {
                            setRadioValue(e.target.value);
                            if (e.target.value === 'from') setSingleDate(undefined)
                            if (e.target.value === 'fromStart') {
                                setSingleDate(undefined)
                                const from = range?.[0] ? new Date(range[0] as any) : new Date();
                                setRange && setRange([from, addYears(new Date(), 5)]);
                            }
                            setMasterFilterState(tableName, {radio_value: e.target.value})
                        }}
                    >
                        <FormControlLabel
                            value='from'
                            control={<Radio/>}
                            label="בין תאריכים"
                            labelPlacement='top'
                        />
                        <FormControlLabel
                            value='unique'
                            control={<Radio/>}
                            label="עד תאריך הפקדה"
                            labelPlacement='top'
                        />
                        {enableFromDateFilter && (
                            <FormControlLabel
                                value='fromStart'
                                control={<Radio/>}
                                label="החל מתאריך"
                                labelPlacement='top'
                            />
                        )}
                    </RadioGroup>
                </Grid>
            }
            <Grid item style={{ flex: '0 0 auto' }} >
                {(status && status?.length > 0) && <Autocomplete
                    value={status}
                    onChange={(e: any, v: DocumentStatus[] | null) => {
                        if (v) setStatus(v);
                        setMasterFilterState(tableName, v)
                    }}
                    multiple
                    options={Object.keys(documentStatuses)}
                    getOptionLabel={(o) => documentStatuses[o]}
                    size='small'
                    autoHighlight
                    renderInput={(params) => <TextField {...params} label={<FormattedMessage id='Choose Status' />}
                                                        size='small' />}
                />}

            </Grid>


            {(byOrder || setByOrder) &&
                <Grid item style={{ flex: '0 0 auto' }} >
                    <FormGroup>
                        <FormControlLabel
                            control={<Checkbox checked={byOrder} onChange={(e) => {
                                if (setByOrder) setByOrder(e.target.checked);
                            }}/>}
                            label="רק לפי הזמנות"
                        />
                    </FormGroup>
                </Grid>
            }
            {(inventory || setInventory) &&
                <Grid item style={{ flex: '0 0 auto' }} >
                    <FormGroup>
                        <FormControlLabel
                            control={<Checkbox checked={inventory} onChange={(e) => {
                                if (setInventory) setInventory(e.target.checked);
                            }}/>}
                            label="עם מלאי"
                        />
                    </FormGroup>
                </Grid>
            }
            {(byBase || setByBase) &&
                <Grid item style={{ flex: '0 0 auto' }} >
                    <FormGroup>
                        <FormControlLabel
                            control={<Checkbox checked={byBase} onChange={(e) => {
                                if (setByBase) setByBase(e.target.checked);
                            }}/>} 
                            label="רק בסיס"
                    />
                </FormGroup>
            </Grid> }

            {savePriceInClient && setSavePriceInClient &&
                <Grid item style={{ flex: '0 0 auto' }} >
                    <FormGroup>
                        <FormControlLabel
                            control={
                                <Checkbox checked={savePriceInClient} onChange={(e) => {
                                    if (setSavePriceInClient) setSavePriceInClient(e.target.checked);

                                }
                                } />
                            }
                            label="שמור מחיר בלקוח"
                        />
                    </FormGroup>
                </Grid>
            }

            {/* Statistics controls inline */}
            {(setStatisticsEnabled || setDistanceStd || setShowExceptionsOnly || setGroupingMode) && (
                <Grid item style={{ display: 'flex', alignItems: 'center', gap: 12, flex: '0 0 auto' }} >
                    <FormGroup row>
                        {setStatisticsEnabled && (
                            <FormControlLabel
                                control={<Checkbox checked={!!statisticsEnabled} onChange={(e) => setStatisticsEnabled && setStatisticsEnabled(e.target.checked)} />}
                                label="סטטיסטיקה"
                            />
                        )}
                        {setGroupingMode && (
                            <>
                                <Typography variant="body2" style={{ marginInlineStart: 8 }}>חישוב לפי</Typography>
                                <Select size="small" value={groupingMode || 'byProduct'} onChange={(e) => setGroupingMode && setGroupingMode(e.target.value)} style={{ width: 140 }}>
                                    <MenuItem value="byClient">לקוח+מוצר</MenuItem>
                                    <MenuItem value="byProduct">מוצר</MenuItem>
                                </Select>
                            </>
                        )}
                        {setDistanceStd && (
                            <>
                                <Typography variant="body2" style={{ marginInlineStart: 8 }}>סטיות תקן</Typography>
                                <Select size="small" value={Number(distanceStd ?? 2)} onChange={(e) => setDistanceStd && setDistanceStd(Number(e.target.value))} style={{ width: 100 }}>
                                    {[0.5, 1, 1.5, 2,2.5, 3].map(v => (
                                        <MenuItem key={v} value={v}>{v} σ</MenuItem>
                                    ))}
                                </Select>
                            </>
                        )}
                        {setShowExceptionsOnly && (
                            <FormControlLabel
                                control={<Checkbox checked={!!showExceptionsOnly} onChange={(e) => setShowExceptionsOnly && setShowExceptionsOnly(e.target.checked)} />}
                                label="רק חריגים"
                            />
                        )}
                        {/* Outlier type toggles next to statistics controls */}
                        {statisticsEnabled && (
                            <>
                                <FormControlLabel
                                    control={<Checkbox checked={(includePriceOutliers !== undefined ? includePriceOutliers : ((localStorage.getItem('statsIncludePrice') ?? '1') === '1'))} onChange={(e) => {
                                        const val = e.target.checked;
                                        if (setIncludePriceOutliers) {
                                            setIncludePriceOutliers(val);
                                        } else {
                                            localStorage.setItem('statsIncludePrice', val ? '1' : '0');
                                        }
                                        onOutlierTogglesChange && onOutlierTogglesChange();
                                    }} />}
                                    label="Price outliers"
                                />
                                <FormControlLabel
                                    control={<Checkbox checked={(includeRatioOutliers !== undefined ? includeRatioOutliers : ((localStorage.getItem('statsIncludeRatio') ?? '1') === '1'))} onChange={(e) => {
                                        const val = e.target.checked;
                                        if (setIncludeRatioOutliers) {
                                            setIncludeRatioOutliers(val);
                                        } else {
                                            localStorage.setItem('statsIncludeRatio', val ? '1' : '0');
                                        }
                                        onOutlierTogglesChange && onOutlierTogglesChange();
                                    }} />}
                                    label="Ratio outliers"
                                />
                            </>
                        )}
                    </FormGroup>
                </Grid>
            )}
        </Grid>
    )

}

const Calendar = ({cid, name}: { cid: string; name: string }) => {
    const [status, setStatus] = React.useState<DocumentStatus[]>(['open', 'approved', 'pending_approval', 'closed','partly_closed']);
    const [range, setRange] = React.useState<RangeInput<null>>([startOfMonth(subDays(startOfMonth(new Date()), 1)), addDays(endOfMonth(new Date()), 7)]);
    const dispatch = useDispatch();
    const cache = useQueryClient();
    const {
        data: docs,
        isLoading,
        refetch
    } = useGetCustomerAllDocuments(parseJSON(range[0]!), parseJSON(range[1]!), true, cid, true, false, undefined, true, "CUSTOMER_DOCUMENTS_SPECIFIC");
    const [documents, setDocs] = React.useState<ExtendedDocument[]>([]);
    const pool = "CUSTOMER_DOCUMENTS_SPECIFIC"
    // fetch events data
    // eslint-disable-next-line prefer-const
    React.useEffect(() => {

        if (!isLoading && range && range[0] != null && range[1] != null) {
            cache.removeQueries(pool);
            refetch();
        }
    }, [range, dispatch]);

    React.useEffect(() => {
        if (docs)
            setDocs(docs?.filter((d) => (d.type != 'debt' || d?.nkObject?.state == 0) && (status.length === 0 || status.indexOf(d.status) > -1)));
        else
            setDocs([]);

    }, [status, docs]);


    return (
        <>
            {isLoading && <Loader/>}
            <MainCard>
                <Box sx={{pb: 3}}>
                    <DocumentsFilterBar status={status} setStatus={setStatus} range={range} setRange={setRange}
                                        isLoading={isLoading}/>
                </Box>
                <DocumentsTable data={documents ?? []} pool={pool}/>
            </MainCard>
        </>
    );
};

export default Calendar;
